/**
 * Visões de navegação alinhadas às visões fixas do SGI (API `VisaoSistema`).
 * Const (não `enum`) para permitir testes unitários com Node strip-types.
 */
export const NavigationView = {
  Administrador: 1,
  Corregedoria: 2,
  Subcorregedoria: 3,
  DefensorDiretor: 4,
  Defensor: 5,
  Estagiario: 6,
  Colaborador: 7,
  RecursosHumanos: 8,
  Auxiliar: 9,
  GestorRelatorios: 10,
} as const;

export type NavigationView = (typeof NavigationView)[keyof typeof NavigationView];

/** Valor legado 0 (SysAdmin) — unificado em {@link NavigationView.Administrador}. */
export const NAVIGATION_VIEW_SYS_ADMIN_LEGADO = 0;

export const NAVIGATION_VIEW_LABELS: Record<NavigationView, string> = {
  [NavigationView.Administrador]: 'Administrador(a)',
  [NavigationView.Corregedoria]: 'Corregedoria',
  [NavigationView.Subcorregedoria]: 'Subdefensoria Pública-Geral',
  [NavigationView.DefensorDiretor]: 'Defensor(a) Diretor(a)',
  [NavigationView.Defensor]: 'Defensor(a)',
  [NavigationView.Estagiario]: 'Estagiário(a)',
  [NavigationView.Colaborador]: 'Colaborador(a)',
  [NavigationView.RecursosHumanos]: 'Recursos Humanos',
  [NavigationView.Auxiliar]: 'Auxiliar',
  [NavigationView.GestorRelatorios]: 'Gestor de Relatórios',
};

/** Usuários de suporte/desenvolvimento com visão administrativa garantida. */
export const SYSADMIN_USER_IDS = [1, 2] as const;

/** Apenas este usuário pode alternar visão para testes. */
export const NAVIGATION_VIEW_SWITCH_USER_ID = 2;

/** Normaliza visão da API ou legado (0 → Administrador). String vazia = visão automática (null). */
export function normalizeNavigationView(
  view: number | NavigationView | string | null | undefined,
): NavigationView | null {
  if (view == null) return null;
  if (typeof view === 'string' && view.trim() === '') return null;
  if (!Number.isFinite(Number(view))) return null;
  const v = Number(view);
  if (v === NAVIGATION_VIEW_SYS_ADMIN_LEGADO) return NavigationView.Administrador;
  return (Object.values(NavigationView) as number[]).includes(v)
    ? (v as NavigationView)
    : null;
}
